module.exports = __webpack_public_path__ + "static/media/revolut.1d6a2a09.svg";